import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterTaskStatusValue,
  UniversalFilterTaskStatusModes,
  UniversalFilterTaskStatusFilterOptions,
  UniversalFilterTaskStatusOnChange
} from './UniversalFilterTaskStatus.types';

import { useUniversalFilterTaskStatus } from './hooks/useUniversalFilterTaskStatus';

import { TasksStatusesMultiSelect } from '../../../../../main/tasks/helpers/TasksStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterTaskStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterTaskStatusValue;
  i18nName: I18nText;
  options?: UniversalFilterTaskStatusFilterOptions;
  autoFocus?: boolean;
  onChange: UniversalFilterTaskStatusOnChange;
}

function UniversalFilterTaskStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  options,
  autoFocus,
  onChange
}: UniversalFilterTaskStatusProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterTaskStatus({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterTaskStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <TasksStatusesMultiSelect
        key={filterState.mode}
        value={filterState.statuses || []}
        availableStatuses={options?.availableStatuses}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterTaskStatus;
